import primaryComponents, {
  AsyncSelectField,
} from "../../../../primaryComponents";
import styles from "./styles.module.scss";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import { useGetPurchaseOrdersForSelectField } from "../../../../../hooks/api/queries";

export const BasicInfo = ({
  gRForm,
  pODetails = {},
  isEditMode = false,
  setGRForm = () => {},
  ...validationParams
}) => {
  const {
    register,
    control,
    formState: { errors },
    trigger,
  } = validationParams;
  const { loadOptions } = useGetPurchaseOrdersForSelectField({
    queryParams: { has_receivables: true },
  });

  return (
    <div className={styles.basicInfo}>
      <div
        className={`${globalStyles.cardWithBorder} flex-md-row w-100 pb-1`}
        style={{ columnGap: "15px" }}
      >
        <div className="w-100">
          <AsyncSelectField
            control={control}
            name={"po_id"}
            register={register}
            label={"Select PO"}
            labelDescription="Select a PO number for this GRN"
            isRequired
            value={gRForm.po_number || undefined}
            nameKey={"name"}
            idKey={"id"}
            loadOptions={loadOptions}
            isDisabled={isEditMode}
            errorMessage={errors?.po_id}
            onChange={(value) => {
              setGRForm((prevState) => ({
                ...prevState,
                po_id: value,
              }));
            }}
          />
        </div>
        <div className="w-100">
          <primaryComponents.DateInputV2
            control={control}
            name={"gr_date"}
            register={register}
            label={"GR Date"}
            labelDescription="Select the date this GRN was created"
            classNames="white"
            isRequired
            value={gRForm.gr_date}
            errorMessage={errors?.gr_date}
            onKeyUp={() => errors?.gr_date && trigger("gr_date")}
            onChange={({ target: { value } }) => {
              setGRForm((prevState) => ({
                ...prevState,
                gr_date: value,
              }));
            }}
          />
        </div>
      </div>

      <div className="d-flex mt-3" style={{ columnGap: "50px" }}>
        {/* <h5 className="font-weight-normal gray--text">
          <span style={{ fontStyle: "italic" }}>Store: </span>
          <span className="purple--text">
            {pODetails?.store?.name || "N/A"}
          </span>
        </h5> */}

        <h5 className="font-weight-normal gray--text">
          <span style={{ fontStyle: "italic" }}>Supplier: </span>
          <span className="purple--text">
            {pODetails?.supplier?.name || "N/A"}
          </span>
        </h5>
      </div>
    </div>
  );
};
